/* eslint-disable max-len */
/* eslint-disable max-statements */
import {useEffect, useState} from 'react';
import {getExonerationPerc} from '../../../../utils';
import {completeWithCeros} from '../../../../../floatingInventory/utils/commonUtils';
import {formFloatInvErrors} from '../../../../../floatingInventory/constants/initialErrors';
import {fieldHasError} from '../../../../../floatingInventory/utils/formUtils';
import {dataNames} from '../../../../../floatingInventory/constants/dataNames';
import {passportDigits} from '../../../../../floatingInventory/constants/commons';
import {UserGroup} from '../../../../../floatingInventory/constants/userGroup';

const useClient = ({
  code,
  data,
  dealerId,
  exonerationsList,
  setData,
  minValue,
  formValidationsClient,
  fetchFlInventoryAttachments,
  closeModal,
  fetchClientManagementInfo,
  clearClientManagement,
  fetchClientManagementList,
  addClientManagement,
  updateClientManagement,
  addMessageBoxError,
  fetchVerifyFloatClient,
  currentFlUserGroup,
  dealerRuc,
}) => {
  const clientFilesKey = `${data.document}/${data.dealerRuc}`;
  const [dataError, setDataError] = useState(formFloatInvErrors);
  useEffect(() => {
    if (code && dealerRuc) {
      fetchClientManagementInfo(code, dealerRuc);
      fetchFlInventoryAttachments(`${code}/${dealerRuc}`);
    } else {
      setData('dealerRuc', dealerId);
    }
    return () => clearClientManagement();
  }, []);
  
  const handleChange = (name, value, validations = []) => {
    const validationsArray = [...validations];
    let errorValue = {'value': value, 'error': false};
    for (let i = 0; i < validationsArray.length; i++) {
      errorValue = validationsArray[i](errorValue.value);
      if (errorValue.error) {
        break;
      }
    }

    if (value?.length === 0) {
      setData(name, errorValue?.value);
    }

    if (errorValue?.error) {
      setData(name, errorValue?.value);
      setDataError({
        ...dataError,
        [`${name}Error`]: errorValue.error,
      });
    } else {
      setData(name, errorValue?.value);
      setDataError({
        ...dataError,
        [`${name}Error`]: false,
      });
    }
  };

  const handleInputTextChange = (e, {name, value}, validation, extraData = null) => {
    const caret = e.target.selectionStart;
    const element = e.target;
    window.requestAnimationFrame(() => {
      element.selectionStart = caret;
      element.selectionEnd = caret;
    });
    handleChange(name, value, validation);
  };

  const validatePercentajeExoneration = () => {
    const exonerationPercentaje = getExonerationPerc(data.clientType, data.discapacityPerc, exonerationsList);
    if (parseInt(data.discapacityPerc, 10) < minValue || parseInt(data.discapacityPerc, 10) > 100) {
      setDataError((dataError) => ({
        ...dataError,
        'discapacityPercError': {'content': `INGRESE UN VALOR ENTRE ${minValue} Y 100`},
      }));
    }
    setData('exonerationPerc', exonerationPercentaje);
  };

  const percDiscHasMinError = () => {
    if (parseInt(data.discapacityPerc, 10) < minValue || parseInt(data.discapacityPerc, 10) > 100) {
      return true;
    }
    return false;
  };
  useEffect(() => {
    validatePercentajeExoneration();
  }, [data.clientType, data.discapacityPerc]);

  const handleDocumentChange = (name, value, validation) => {
    let valueToUpdate = value;
    if (data.documentType === 'P') {
      valueToUpdate = completeWithCeros(value, passportDigits);
    }
    value && fetchVerifyFloatClient(valueToUpdate, data.dealerRuc);
    handleChange(name, valueToUpdate, validation);
  };

  const handleDocumentRepChange = (name, value, validation) => {
    let valueToUpdate = value;
    if (data.legalRepresentativeType === 'P') {
      valueToUpdate = completeWithCeros(value, passportDigits);
    }
    handleChange(name, valueToUpdate, validation);
  };

  const handleClientTypeChange = (name, value, validation) => {
    let valuedocumentType = null;
    if (value === '001') {
      valuedocumentType = 'C';
    } else {
      valuedocumentType = 'R';
    }
    handleChange('documentType', valuedocumentType, formValidationsClient.documentType(data));
    handleChange(name, value, validation);
  };

  useEffect(() => {
    if (data.documentType === 'P') {
      data.document && setData('document', completeWithCeros(data.document, passportDigits));
    }
  }, [data.documentType]);

  useEffect(() => {
    if (data.legalRepresentativeType === 'P') {
      data.legalRepresentativeId && setData('legalRepresentativeId', completeWithCeros(data.legalRepresentativeId, passportDigits));
    }
  }, [data.legalRepresentativeType]);

  const handleValidateChange = (
    name,
    value,
    validations = [],
    extraData = {}
  ) => {
    const validationsArray = [...validations];
    let errorValue = {'value': value, 'error': false};
    for (let i = 0; i < validationsArray.length; i++) {
      errorValue = validationsArray[i](errorValue.value, extraData);
      if (errorValue.error) {
        break;
      }
    }
    if (errorValue?.error) {
      setDataError((dataError) => ({
        ...dataError,
        [`${name}Error`]: errorValue?.error,
      }));
    } else {
      setDataError((dataError) => ({
        ...dataError,
        [`${name}Error`]: false,
      }));
    }
  };

  const handleSendData = () => {
    const dataEntries = Object.keys(formValidationsClient);
    let errors = '';
    dataEntries.forEach((key) => {
      const value = data[key];
      if (key) {
        const validations = formValidationsClient[key](data);
        handleValidateChange(key, value, validations, {minValue});
        if (fieldHasError(value, validations)) {
          errors += `${dataNames[key]} \n`;
        }
        if (key === 'discapacityPerc' && percDiscHasMinError()) {
          errors += `${dataNames[key]} \n`;
        }
      }
    });
    if (!errors) {
      if (!code) {
        addClientManagement(data);
      } else {
        updateClientManagement(code, dealerId, data);
      }
      fetchClientManagementList(dealerId);
      code && closeModal();
    } else {
      addMessageBoxError(`CORREGIR LOS CAMPOS:\n${errors}`);
    }
  };
  const isAvailable = ([UserGroup.coachDealer, UserGroup.tdeUser].includes(currentFlUserGroup));

  return {
    'actions': {
      setData,
      handleDocumentChange,
      handleClientTypeChange,
      handleSendData,
      handleChange,
      handleDocumentRepChange,
      handleInputTextChange,
    },
    'data': {
      data,
      dataError,
      isAvailable,
      clientFilesKey,
    },
  };
};
export default useClient;
